import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { View } from "react-native-ui-lib";
import { ModalCloseButton } from "@towersystems/roam-common-native";
import { ExportModalRootParamList, SaleRootParamList } from "../../../../types";
import { createStackHeaderNavigator } from "@towersystems/roam-common-native";
import { useQuerySale } from "../../utils";
import { SaleContext } from "../../utils/sales/context";
import { ExportOptionsModalScreen } from "../ExportOptionsModalScreen";

export type ExportModalRootScreenProps = NativeStackScreenProps<
  SaleRootParamList,
  "ExportModalRootScreen"
> & {};

export const ExportModalRootScreen = ({
  route,
}: ExportModalRootScreenProps) => {
  const Stack = createStackHeaderNavigator<ExportModalRootParamList>();
  const saleId = route.params.saleId;
  const { item: sale } = useQuerySale({ saleId });

  if (!sale) {
    return <View />;
  }

  return (
    <SaleContext.Provider value={{ sale }}>
      <Stack.Navigator>
        <Stack.Group>
          <Stack.Screen
            name="ExportOptionsModalScreen"
            options={{
              title: "Select Option",
              animationEnabled: true,
              cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
              headerLeft: () => <ModalCloseButton type="Close" />,
            }}
            component={ExportOptionsModalScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </SaleContext.Provider>
  );
};
